import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { withRouter } from 'react-router-dom';
import {
    translate,
    DashboardMenuItem,
    MenuItemLink,
} from 'react-admin';

import vnnode from '../vnnode';
import visitors from '../customers';
import sweeps from '../sweeps';
import documentation from '../documentation';
class Menu extends Component {

    static propTypes = {
        onMenuClick: PropTypes.func,
        logout: PropTypes.object,
    };

    render() {
        const { onMenuClick } = this.props;
        return (
            <div>
                {' '}
                <DashboardMenuItem onClick={onMenuClick} />
                <MenuItemLink
                    to={`/vnnode`}
                    primaryText="VN server offering"
                    leftIcon={<vnnode.icon />}
                    onClick={onMenuClick}
                />
                <MenuItemLink
                    to={`/lintranscodev2`}
                    primaryText="Pretested 1st screen results"
                    leftIcon={<sweeps.icon />}
                    onClick={onMenuClick}
                />
                <MenuItemLink
                    to={`/customertest`}
                    primaryText="Test Wizard"
                    leftIcon={<sweeps.icon />}
                    onClick={onMenuClick}
                />
                <MenuItemLink
                    to={`/customer`}
                    primaryText="Customers"
                    leftIcon={<visitors.icon />}
                    onClick={onMenuClick}
                />
                <MenuItemLink
                    to={`/documentation`}
                    primaryText="Documentation"
                    leftIcon={<documentation.icon />}
                    onClick={onMenuClick}
                />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    open: state.admin.ui.sidebarOpen,
    theme: state.theme,
    locale: state.i18n.locale,
});

const enhance = compose(
    withRouter,
    connect(
        mapStateToProps,
        {}
    ),
    translate
);

export default enhance(Menu);